export const SEND_SMS_STATUSES = {
  sendSmsCodeSuccess: 'success',
  sendSmsCodeRegistering: 'registering',
  sendSmsCodeFailure: 'failure',
}

export const PHONE_VERIFY_STATUS = {
  phoneStatusVerifying: 'verifying',
  phoneStatusSuccess: 'success',
  phoneStatusFailure: 'failure',
}

export const REWARDS_LEVEL_REQUIREMENT_KEYS = {
  AUDIENCE_DIVIDEND: 'audienceDividend',
  DEVICE_DIVIDEND: 'deviceDividend',
}

export const KILLI_PAYCHECK_MAX_TIER = 4

export const GENDER_VALUE = {
  MALE: 'm',
  FEMALE: 'f',
  NON_BINARY: 'nb',
}

export const PROFILE_DATA_FIELDS = {
  ADVERTISING_ID: 'advertisingId',
  AUTO_REDEEM_SHARES_ENABLED: 'autoRedeemSharesEnabled',
  DATE_OF_BIRTH: 'dateOfBirth',
  EMAIL: 'email',
  GENDER: 'gender',
  PHONE_NUMBER: 'phoneNumber',
  REGION: 'region',
  POSTAL_CODE: 'postalCode',
}

export const PROFILE_PROPERTIES = {
  [PROFILE_DATA_FIELDS.ADVERTISING_ID]: {
    valueFieldKey: 'advertisingId',
    apiFieldKey: 'advertising_id',
  },
  [PROFILE_DATA_FIELDS.AUTO_REDEEM_SHARES_ENABLED]: {
    valueFieldKey: 'autoRedeemSharesEnabled',
    apiFieldKey: 'auto_redeem_shares_enabled',
  },
  [PROFILE_DATA_FIELDS.DATE_OF_BIRTH]: {
    valueFieldKey: 'dateOfBirth',
    apiFieldKey: 'date_of_birth',
    sourceFieldKey: 'dateOfBirthSource',
  },
  [PROFILE_DATA_FIELDS.EMAIL]: {
    valueFieldKey: 'email',
    apiFieldKey: 'email',
    sourceFieldKey: 'emailSource',
    verifiedFieldKey: 'verifiedEmail',
  },
  [PROFILE_DATA_FIELDS.GENDER]: {
    valueFieldKey: 'gender',
    apiFieldKey: 'gender',
    sourceFieldKey: 'genderSource',
  },
  [PROFILE_DATA_FIELDS.PHONE_NUMBER]: {
    valueFieldKey: 'phoneNumber',
    apiFieldKey: 'phone_number',
    sourceFieldKey: 'phoneNumberSource',
  },
  [PROFILE_DATA_FIELDS.POSTAL_CODE]: {
    valueFieldKey: 'postalCode',
    apiFieldKey: 'postal_code',
    sourceFieldKey: 'postalCodeSource',
  },
  [PROFILE_DATA_FIELDS.REGION]: {
    valueFieldKey: 'region',
    apiFieldKey: 'region',
    sourceFieldKey: 'regionSource',
  },
}

export const IDENTIFIER_ADD_ENDPOINT_ERROR_CODES = {
  INVALID_IDENTIFIER_ERROR: 'INVALID_IDENTIFIER_ERROR',
  COGNITO_POOL_ERROR: 'COGNITO_POOL_ERROR',
  IDENTIFIER_LIMIT_ERROR: 'IDENTIFIER_LIMIT_ERROR',
  IDENTIFIER_TAKEN_ERROR: 'IDENTIFIER_TAKEN_ERROR',
  DEFAULT_ERROR: 'DEFAULT_ERROR',
  EXPIRED_TOKEN_ERROR: 'EXPIRED_TOKEN_ERROR',
  INVALID_TOKEN_ERROR: 'INVALID_TOKEN_ERROR',
  INVALID_TOKEN_CONTENT_ERROR: 'INVALID_TOKEN_CONTENT_ERROR',
  INVALID_SMS_CODE_ERROR: 'INVALID_SMS_CODE_ERROR',
  ACCOUNT_NOT_FOUND_ERROR: 'ACCOUNT_NOT_FOUND_ERROR',
}

export const IDENTIFIER_REMOVE_ENDPOINT_ERROR_CODES = {
  INVALID_IDENTIFIER_ERROR: 'INVALID_IDENTIFIER_ERROR',
  COGNITO_POOL_ERROR: 'COGNITO_POOL_ERROR',
  IDENTIFIER_NOT_FOUND_ERROR: 'IDENTIFIER_NOT_FOUND_ERROR',
  IDENTIFIER_PRIMARY_ERROR: 'IDENTIFIER_PRIMARY_ERROR',
  DEFAULT_ERROR: 'DEFAULT_ERROR',
}

export const IDENTIFIER_SET_PRIMARY_ENDPOINT_ERROR_CODES = {
  INVALID_IDENTIFIER_ERROR: 'INVALID_IDENTIFIER_ERROR',
  COGNITO_POOL_ERROR: 'COGNITO_POOL_ERROR',
  IDENTIFIER_NOT_FOUND_ERROR: 'IDENTIFIER_NOT_FOUND_ERROR',
  IDENTIFIER_PRIMARY_ERROR: 'IDENTIFIER_PRIMARY_ERROR',
  DEFAULT_ERROR: 'DEFAULT_ERROR',
}

export const USER_HANDLE_ADD_ENDPOINT_ERROR_CODES = {
  USER_HANDLE_TAKEN_ERROR: 'ERROR_USER_HANDLE_TAKEN',
  DEFAULT_ERROR: 'DEFAULT_ERROR',
}

export const EARN_MORE_FLOW_SCREEN_KEYS = {
  PROFILE_REWARDS: 'PROFILE_REWARDS',
  POLLS_EXPLAINER: 'POLLS_EXPLAINER',
}

export const EARN_MORE_FLOW_SCREENS_ORDER = [
  EARN_MORE_FLOW_SCREEN_KEYS.PROFILE_REWARDS,
  EARN_MORE_FLOW_SCREEN_KEYS.POLLS_EXPLAINER,
]

export const UPLOAD_PROFILE_PICTURE_ERROR_CODES = {
  PROFILE_IMAGE_FILE_SIZE_TOO_LARGE: 'PROFILE_IMAGE_FILE_SIZE_TOO_LARGE',
  PROFILE_IMAGE_UPLOAD_FAILED: 'PROFILE_IMAGE_UPLOAD_FAILED',
}

export default {
  SEND_SMS_STATUSES,
  PHONE_VERIFY_STATUS,
}
